module.exports = __webpack_public_path__ + "static/media/solution-tube-kplusfull-open.53a7ecf5.svg";